<template>
    <div v-if="registration.duplicates" class="duplicates">
        <h2>{{ $t('support.duplicates.header') }}</h2>
        <div>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>{{ $t('support.duplicates.tableColumn.type') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.churchName') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.email') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.phone') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.city') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.country') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.website') }}</th>
                        <th>{{ $t('support.duplicates.tableColumn.setupState') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="duplicate in registration.duplicates.internDuplicates" class="duplicate-input">
                        <td>{{ $t('support.duplicates.intern') }} (#{{ duplicate.id }})</td>
                        <td>{{ duplicate.name }}</td>
                        <td>{{ duplicate.email }}</td>
                        <td>{{ duplicate.telefonprivat }}</td>
                        <td>{{ duplicate.ort }}</td>
                        <td>{{ duplicate.land }}</td>
                        <td>{{ duplicate.website }}</td>
                        <td></td>
                    </tr>
                    <tr v-for="duplicate in registration.duplicates.ccpDuplicates" class="duplicate-input">
                        <td>{{ $t('support.duplicates.ccp') }}</td>
                        <td>{{ duplicate.churchName }}</td>
                        <td>{{ duplicate.email }}</td>
                        <td>{{ duplicate.phone }}</td>
                        <td>{{ duplicate.city }}</td>
                        <td>{{ duplicate.countryCode }}</td>
                        <td>{{ duplicate.website }}</td>
                        <td>{{ duplicate.setupStatus }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {};
    },
    computed: {
        registration() {
            return this.$store.getters['support/loadedRegistration'];
        }
    }
};
</script>
